import React from 'react';

function ChurchList({ churches, loading, pagination, onChurchClick, onPageChange }) {
  if (loading) {
    return (
      <div className="table-container">
        <div className="loading">Loading churches</div>
      </div>
    );
  }

  if (churches.length === 0) {
    return (
      <div className="table-container">
        <div className="empty-state">
          <h3>No churches found</h3>
          <p>Try adjusting your filters or run the scraper to collect more data</p>
        </div>
      </div>
    );
  }

  return (
    <div className="table-container">
      <div className="table-header">
        <h2>Churches ({pagination?.total || 0})</h2>
      </div>

      <table>
        <thead>
          <tr>
            <th>Name</th>
            <th>Location</th>
            <th>Denomination</th>
            <th>Contact</th>
            <th>Pastor</th>
          </tr>
        </thead>
        <tbody>
          {churches.map((church) => (
            <tr key={church.id} onClick={() => onChurchClick(church)}>
              <td>
                <strong>{church.name}</strong>
              </td>
              <td>
                {church.city}, {church.state} {church.zip}
              </td>
              <td>{church.denomination || '—'}</td>
              <td>
                {church.email && (
                  <div style={{ marginBottom: '0.2rem' }}>
                    📧 {church.email}
                  </div>
                )}
                {church.phone && (
                  <div>📞 {church.phone}</div>
                )}
                {!church.email && !church.phone && '—'}
              </td>
              <td>{church.pastor_name || '—'}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {pagination && pagination.pages > 1 && (
        <div className="pagination">
          <button
            className="btn-secondary"
            disabled={pagination.page === 1}
            onClick={() => onPageChange(pagination.page - 1)}
          >
            Previous
          </button>
          <span>
            Page {pagination.page} of {pagination.pages}
          </span>
          <button
            className="btn-secondary"
            disabled={pagination.page === pagination.pages}
            onClick={() => onPageChange(pagination.page + 1)}
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
}

export default ChurchList;
